<template>
  <a-config-provider :locale="pl_PL">
    <div class="main-search-section">
      <div ref="mainSearch" class="main-search">
        <div v-if="offersLoading" class="main-search__loading-layer">
          <a-spin>
            <a-icon
              slot="indicator"
              type="loading"
              style="font-size: 32px"
              spin
            />
          </a-spin>
        </div>
        <div class="main-search__primary">
          <div class="main-search__first-block">
            <div class="cell cell_transport desktop-bottom">
              <span class="d-none d-md-inline-block mb-2"
                >Rodzaj transportu</span
              >
              <div class="cell__form-control">
                <div class="transport-type">
                  <a-radio-group
                    v-model="valDojazd"
                    :default-value="valDojazd"
                    @change="handleChangeDojazd"
                  >
                    <a-radio-button
                      v-for="doj in dojazd"
                      :key="doj.idx"
                      :value="doj.idx"
                      :class="doj.cssClass"
                    >
                      <span class="tt-label">
                        <span class="tt-icon"></span>
                        <span class="tt-text">{{ doj.val }}</span>
                      </span>
                    </a-radio-button>
                  </a-radio-group>
                </div>
              </div>
            </div>
            <div class="cell cell_direction desktop-top">
              <span class="d-inline-block mb-2">Kierunek podróży</span>
              <T1KierunkiModal
                v-if="isMobile"
                :disabled="!getIsKierunkiDisabled()"
                :groupTitle="groupTitle"
                @dataFromDests="dataDestsReceived"
              />
              <T1KierunkiDropdown
                v-else
                :disabled="!getIsKierunkiDisabled()"
                :groupTitle="groupTitle"
                @dataFromDests="dataDestsReceived"
              />
            </div>
          </div>
          <div class="main-search__second-block">
            <div class="cell cell_dates">
              <span class="d-inline-block mb-2">Termin wyjazdu</span>
              <div class="cell__form-control form-control-yellow">
                <a-input
                  read-only
                  v-model="datesRange"
                  @click="showModalTermin"
                >
                  <a-icon
                    slot="suffix"
                    type="calendar"
                    :style="{ color: '#b9b9b9' }"
                  />
                </a-input>
              </div>
              <a-modal
                :confirmLoading="confirmLoadingTermin"
                :visible="visibleTermin"
                okText="Wybierz"
                title="Wybierz termin wyjazdu"
                width="666px"
                wrapClassName="modal-mob"
                @cancel="handleCancelTermin"
              >
                <div class="datepicker-container">
                  <a-range-picker
                    :value="datesRangeVal"
                    :allowClear="false"
                    :placeholder="['Wyjazd od', 'Powrót przed']"
                    :disabled-date="disabledDate"
                    :getCalendarContainer="getCalendarContainer()"
                    :inputReadOnly="true"
                    dropdownClassName="fitted-datepicker"
                    open
                    @change="handleRangePicker"
                  >
                  </a-range-picker>
                </div>
                <template slot="footer">
                  <div class="d-flex">
                    <a-button @click="clear"> Wyczyść </a-button>
                    <a-button class="ml-auto" @click="handleCancelTermin">
                      Anuluj
                    </a-button>
                    <a-button type="primary" @click="handleOkTermin">
                      Wybierz
                    </a-button>
                  </div>
                </template>
              </a-modal>
            </div>
            <div class="cell cell_participants">
              <span class="d-inline-block mb-2">Uczestnicy</span>
              <div class="cell__form-control form-control-yellow">
                <a-input
                  v-model="valUczestnicy"
                  @click="showModalUczestnicy"
                  read-only
                />
              </div>
              <a-modal
                :confirmLoading="confirmLoadingUczestnicy"
                :visible="visibleUczestnicy"
                okText="Wybierz"
                title="Uczestnicy"
                wrapClassName="modal-mob"
                @ok="handleOkUczestnicy"
                @cancel="handleCancelUczestnicy"
              >
                <div class="pb-24">
                  <a-row :gutter="16">
                    <a-col :span="12">
                      <span class="label">Dorośli</span>
                      <a-select
                        v-model="valAdt"
                        :defaultValue="[2]"
                        class="w-100"
                        @change="handleChangeAdt"
                      >
                        <a-select-option v-for="i in 5" :key="i">{{
                          i
                        }}</a-select-option>
                      </a-select>
                    </a-col>

                    <a-col :span="12">
                      <span class="label">Dzieci</span>
                      <a-select
                        v-model="valChd"
                        :defaultValue="[0]"
                        class="w-100"
                        @change="handleChangeChd"
                      >
                        <a-select-option v-for="i in 5" :key="i - 1">{{
                          i - 1
                        }}</a-select-option>
                      </a-select>
                    </a-col>
                  </a-row>
                </div>
                <div v-show="getVisible(1)" class="pb-24">
                  <a-row :gutter="[16, 16]">
                    <a-col :span="12">
                      <span class="label">Wiek dziecka 1</span>
                      <a-select
                        v-model="valChd1"
                        :defaultValue="[3]"
                        class="w-100"
                        @change="handleChangeChage1"
                      >
                        <a-select-option v-for="i in 16" :key="i - 1">{{
                          wiekdzieci[i - 1]
                        }}</a-select-option>
                      </a-select>
                    </a-col>

                    <a-col :span="12" v-show="getVisible(2)">
                      <span class="label">Wiek dziecka 2</span>
                      <a-select
                        v-model="valChd2"
                        :defaultValue="[3]"
                        class="w-100"
                        @change="handleChangeChage2"
                      >
                        <a-select-option v-for="i in 16" :key="i - 1">{{
                          wiekdzieci[i - 1]
                        }}</a-select-option>
                      </a-select>
                    </a-col>

                    <a-col :span="12" v-show="getVisible(3)">
                      <span class="label">Wiek dziecka 3</span>
                      <a-select
                        v-model="valChd3"
                        :defaultValue="[3]"
                        class="w-100"
                        @change="handleChangeChage3"
                      >
                        <a-select-option v-for="i in 16" :key="i - 1">{{
                          wiekdzieci[i - 1]
                        }}</a-select-option>
                      </a-select>
                    </a-col>

                    <a-col :span="12" v-show="getVisible(4)">
                      <span class="label">Wiek dziecka 4</span>
                      <a-select
                        v-model="valChd4"
                        :defaultValue="[3]"
                        class="w-100"
                        @change="handleChangeChage4"
                      >
                        <a-select-option v-for="i in 16" :key="i - 1">{{
                          wiekdzieci[i - 1]
                        }}</a-select-option>
                      </a-select>
                    </a-col>
                  </a-row>
                </div>
              </a-modal>
            </div>
            <div class="cell cell_departure">
              <span class="d-inline-block mb-2">Wyjazd z</span>
              <div class="cell__form-control form-control-yellow">
                <a-select
                  class="w-100 select-multiple"
                  :defaultValue="[]"
                  dropdownClassName="fitted-dropdown ux-ok"
                  :dropdownMatchSelectWidth="false"
                  mode="multiple"
                  placeholder="Miejsce wyjazdu"
                  showArrow
                  v-model="valWyjazd"
                  @change="handleChangeWyjazd"
                >
                  <a-select-option
                    v-for="item in getFiltryItems('trp_depName')"
                    :id="item.id"
                    :key="item.gCnt"
                    :selected="valWyjazd.includes(item.id)"
                  >
                    <span class="chbox-sim"></span>{{ item.id }}
                  </a-select-option>
                </a-select>
              </div>
            </div>
            <div class="cell cell_search">
              <div class="cell__form-action">
                <button class="btn btn-lg btn-d-blue btn-block" @click="szukaj">
                  Szukaj
                </button>
              </div>
            </div>
          </div>
        </div>
        <div @click="handleExpand()" class="main-search__expand" role="button">
          <span>{{ isExpanded ? "Mniej filtrów" : "Więcej filtrów" }}</span>
        </div>
        <div class="main-search__support" aria-hidden="true">
          <div class="powered">
            <span class="powered__text">powered by</span>
            <span class="powered__image"></span>
          </div>
        </div>
        <transition name="slide">
          <div v-show="isExpanded" class="main-search__secondary">
            <div class="cell cell_food">
              <span class="d-inline-block mb-2">Wyżywienie</span>
              <div class="cell__form-control form-control-yellow">
                <a-select
                  class="w-100 select-multiple"
                  :defaultValue="[]"
                  dropdownClassName="fitted-dropdown ux-ok"
                  :dropdownMatchSelectWidth="false"
                  mode="multiple"
                  placeholder="Dowolne"
                  showArrow
                  v-model="valWyz"
                  @change="handleChangeWyzyw"
                >
                  <a-select-option
                    v-for="item in getMaxFiltry(
                      getFiltryItems('obj_xServiceId')
                    )"
                    :id="getWyzywienie(item.id)"
                    :key="getWyzywienieVal(item.id)"
                    :selected="valWyz.includes(getWyzywienieVal(item.id))"
                  >
                    <span class="chbox-sim"></span>{{ getWyzywienie(item.id) }}
                  </a-select-option>
                </a-select>
              </div>
            </div>
            <div class="cell cell_duration">
              <span class="d-inline-block mb-2">Długość pobytu</span>
              <div class="cell__form-control form-control-yellow">
                <a-select
                  :defaultValue="['dowolny']"
                  class="w-100"
                  v-model="valPobyt"
                  @change="handleChangePobyt"
                >
                  <a-select-option
                    v-for="(item, index) in pobyt"
                    :id="index"
                    :key="index"
                    :selected="valPobyt == index"
                    >{{ item }}</a-select-option
                  >
                </a-select>
              </div>
            </div>
            <div class="cell cell_standard">
              <span class="d-inline-block mb-2">Standard hotelu</span>
              <div class="cell__form-control form-control-yellow">
                <a-select
                  :defaultValue="['dowolny']"
                  class="w-100"
                  v-model="valStandard"
                  @change="handleChangeStandard"
                >
                  <a-select-option
                    v-for="item in getFiltryItems('obj_category')"
                    :key="getStandardVal(item.id)"
                    :selected="valStandard == getStandardVal(item.id)"
                    >{{ getStandard(item.id) }}</a-select-option
                  >
                </a-select>
              </div>
            </div>
            <div class="cell cell_operator">
              <span class="d-inline-block mb-2">Organizator</span>
              <div class="cell__form-control form-control-yellow">
                <a-select
                  :defaultValue="[]"
                  :dropdownMatchSelectWidth="false"
                  class="w-100 select-multiple"
                  dropdownClassName="fitted-dropdown ux-ok"
                  mode="multiple"
                  placeholder="Dowolny"
                  showArrow
                  v-model="valTourop"
                  @change="handleChangeTourop"
                >
                  <a-select-option
                    v-for="item in tourop"
                    :id="item.kod"
                    :key="item.kod"
                    :selected="valTourop.includes(item.kod)"
                  >
                    <span class="chbox-sim"></span>{{ item.nazwa }}
                  </a-select-option>
                </a-select>
              </div>
            </div>
            <div class="cell cell_amenities">
              <span class="d-inline-block mb-2">Udogodnienia</span>
              <div class="cell__form-control form-control-yellow">
                <a-select
                  :defaultValue="[]"
                  :dropdownMatchSelectWidth="false"
                  class="w-100 select-multiple"
                  dropdownClassName="fitted-dropdown ux-ok"
                  mode="multiple"
                  placeholder="Dowolne"
                  showArrow
                  v-model="valXattr"
                  @change="handleChangeXattr"
                >
                  <a-select-option
                    v-for="item in xattributes"
                    :id="item.decimal"
                    :key="item.id"
                    :selected="valXattr.includes(item.id)"
                  >
                    <span class="chbox-sim"></span>{{ item.attributeName }}
                  </a-select-option>
                </a-select>
              </div>
            </div>
            <div class="cell cell_price">
              <span class="d-inline-block mb-2">Cena za osobę dorosłą</span>
              <div class="cell__form-control">
                <div class="price-slider">
                  <div class="price-slider__value">{{ valCena[0] }} zł</div>
                  <div class="price-slider__control">
                    <a-slider
                      range
                      v-model="valCena"
                      :defaultValue="[0, 25000]"
                      :min="0"
                      :max="25000"
                      @afterChange="doSomethingWithSlider"
                    />
                  </div>
                  <div class="price-slider__value">{{ valCena[1] }} zł</div>
                </div>
              </div>
            </div>
            <div class="cell cell_sorting">
              <span class="d-inline-block mb-2">Sortowanie wg</span>
              <div class="cell__form-control form-control-yellow">
                <a-select
                  :defaultValue="[]"
                  class="w-100"
                  v-model="valSort"
                  @change="handleChangeSort"
                >
                  <a-select-option
                    v-for="item in sorts"
                    :id="item.kod"
                    :key="item.kod"
                    :selected="valSort.includes(item.kod)"
                  >
                    {{ item.nazwa }}
                  </a-select-option>
                </a-select>
              </div>
            </div>
            <div class="cell cell_sorting">
              <span class="d-inline-block mb-2">Kolejność sortowania</span>
              <div class="cell__form-control form-control-yellow">
                <a-select
                  :defaultValue="[]"
                  class="w-100"
                  v-model="valSortOrder"
                  @change="handleChangeSortOrder"
                >
                  <a-select-option
                    v-for="item in sortOrders"
                    :id="item.kod"
                    :key="item.kod"
                    :selected="valSortOrder.includes(item.kod)"
                  >
                    {{ item.nazwa }}
                  </a-select-option>
                </a-select>
              </div>
            </div>
          </div>
        </transition>
      </div>
    </div>
  </a-config-provider>
</template>

<script>
import pl_PL from "ant-design-vue/lib/locale-provider/pl_PL";
import axios from "axios";
import moment from "moment";
import "moment/locale/pl";
import * as CONFIG from "../config.js";
import T1KierunkiModal from "./T1KierunkiModal";
import T1KierunkiDropdown from "./T1KierunkiDropdown";
import { wyzywienie } from "../wyzywienie_panel.js";
import { standard } from "../standard.js";
import { pobyt } from "../pobyt.js";
import { tourop } from "../tourops.js";
import { xattributes } from "../xattributes.js";
import { isMobile } from "mobile-device-detect";
import { sorting } from "../sorts.js";
import { sortingOrders } from "../sortOrders.js";
import bigInt from "big-integer";
axios.defaults.withCredentials = false;
moment.locale("pl");

export default {
  name: "main-searcher",
  props: {
    groupTitle: String,
    offersLoading: Boolean,
  },
  data: () => ({
    pl_PL,
    url: "/getfiltry.json",
    dparams: "",
    filtry: [],
    visibleUczestnicy: false,
    visibleTermin: false,
    confirmLoadingTermin: false,
    tourop: tourop.tourops,
    xattributes: xattributes.items,
    confirmLoadingUczestnicy: false,
    wyzyw: wyzywienie.wyzwysz,
    wyzywvals: wyzywienie.wyzvals,
    stan: standard.standards,
    pobyt: pobyt.pob,
    pobytvals: pobyt.pobvals,
    pobytval: "",
    destlocidarr: [],
    wyjazds: "",
    wyjazdarr: [],
    wyjazdvalarr: [],
    wyzyws: "",
    wyzywarr: [],
    wyzywvalarr: [],
    tourops: "",
    touroparr: [],
    touropvalarr: [],
    xattrs: "",
    xattrarr: [],
    xattrvalarr: [],
    dojazdval: "",
    datefrom: "",
    dateto: "",
    adt: 2,
    chd: 0,
    inf: 0,
    standardval: "",
    cenaOd: 0,
    cenaDo: 25000,
    regionlist: {},
    itemshow: false,
    valDojazd: "",
    valPobyt: ["Dowolny"],
    valCena: [0, 25000],
    valWyz: [],
    valTourop: [],
    valXattr: [],
    valWyjazd: [],
    valStandard: "Dowolny",
    datesRange: "Dowolny",
    datesRangeVal: [],
    dateFromVal: "",
    dateToVal: "",
    valUczestnicy: "2 dorosłych",
    valAdt: 2,
    valChd: 0,
    valChd1: 3,
    valChd2: 3,
    valChd3: 3,
    valChd4: 3,
    valSort: [0],
    sorts: sorting.sorts,
    sortVal: 0,
    valSortOrder: ["rosnąco"],
    sortOrders: sortingOrders.sortOrders,
    sortOrderVal: "ASC",
    marks: {
      0: "0 zł",
      25000: {
        label: "25000 zł",
      },
    },
    dojazd: [
      { idx: "", val: "Dowolny", cssClass: "tt-any" },
      { idx: "samolot", val: "Samolotem", cssClass: "tt-plane" },
      { idx: "autokar", val: "Autokarem", cssClass: "tt-bus" },
      { idx: "wlasny", val: "Dojazd własny", cssClass: "tt-individual" },
    ],
    wiekdzieci: [
      "<1",
      "1 rok",
      "2 lata",
      "3 lata",
      "4 lata",
      "5 lat",
      "6 lat",
      "7 lat",
      "8 lat",
      "9 lat",
      "10 lat",
      "11 lat",
      "12 lat",
      "13 lat",
      "14 lat",
      "15 lat",
      "16 lat",
    ],
    chage1: 3,
    chage2: 3,
    chage3: 3,
    chage4: 3,
    isExpanded: false,
    isMobile: isMobile,
    isKierunkiDisabled: true,
    addon: "",
    windowWidth: window.innerWidth,
  }),
  methods: {
    getVisible(i) {
      if (this.chd >= i) {
        return true;
      } else {
        return false;
      }
    },
    handleExpand() {
      const searcher = this.$refs.mainSearch;
      this.isExpanded = !this.isExpanded;

      if (!this.isExpanded && isMobile && this.windowWidth < 992) {
        searcher.scrollIntoView({ behavior: "smooth" });
      }
    },
    getIsKierunkiDisabled() {
      return this.isKierunkiDisabled;
    },
    getFiltry() {
      return axios
        .get(CONFIG.API_URL + this.url + "?" + this.dparams, null, {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            Accept: "application/json",
          },
        })
        .then((response) => {
          /*alert("DATA:" + response.data);
          alert("STATUS:" + response.status);
          alert("DATA ITEMS:" + JSON.stringify(response.data));*/
          return response.data;
        })
        .catch((e) => {
          alert("ERROR" + e);
        });
    },
    getMaxFiltry(arr) {
      var zz = arr.filter(function (value, index) {
        return value.id != "0";
      });
      return zz;
    },
    getFiltryItems(typ) {
      //return this.filtry[i];
      if (this.filtry.length > 0) {
        var bb = this.filtry.filter(function (value, index) {
          return value.id == typ;
        });
        if (
          bb != null &&
          bb instanceof Array &&
          bb[0] &&
          bb[0].f &&
          bb[0].f instanceof Array
        ) {
          return bb[0].f.filter(function (value, index) {
            return !(value.id instanceof Array);
          });
        } else if (bb != null && bb instanceof Array && bb[0] && bb[0].f) {
          let zz = [];
          if (
            bb[0].f instanceof Object &&
            bb[0].f.id instanceof Array &&
            bb[0].f.id.length == 0
          ) {
          } else {
            zz.push(bb[0].f);
          }
          return zz;
        } else {
          return [];
        }
      } else {
        return [];
      }
    },
    getCurrentStyle(current, today) {
      const style = {};
      if (current.date() === 1) {
        style.border = "1px solid #1890ff";
        style.borderRadius = "50%";
      }
      return style;
    },
    handleChangeChage1(value) {
      this.chage1 = value;
      return true;
    },
    handleChangeChage2(value) {
      this.chage2 = value;
      return true;
    },
    handleChangeChage3(value) {
      this.chage3 = value;
      return true;
    },
    handleChangeChage4(value) {
      this.chage4 = value;
      return true;
    },
    handleChangeDojazd(e) {
      this.dojazdval = e.target.value;
      this.dparams = "dojazd=" + this.dojazdval;
      this.valWyjazd = [];
      this.wyjazdvalarr = [];
      this.getFiltry().then((data) => {
        //alert('OFERTY:' + JSON.stringify(data.page.response));
        this.filtry = data.page.response;
        //this.getQueryParams(null, false);
      });
      return true;
    },
    handleChangePobyt(value) {
      this.pobytval = this.getPobytVal(value);
      return true;
    },
    handleChangeWyzyw(value, id) {
      this.wyzywarr.length = 0;
      let list = [];
      id.forEach(function (item, index) {
        list.push(item.data.attrs.id);
      });
      this.wyzywarr = list;
      this.wyzywvalarr = value;
      return true;
    },
    handleChangeWyjazd(value, id) {
      this.wyjazdarr.length = 0;
      let list = [];
      id.forEach(function (item, index) {
        list.push(item.data.attrs.id);
      });
      this.wyjazdarr = list;
      this.wyjazdvalarr = value;
      return true;
    },
    handleChangeTourop(value, id) {
      this.touroparr.length = 0;
      let list = [];
      id.forEach(function (item, index) {
        list.push(item.data.attrs.id);
      });
      this.touroparr = list;
      this.touropvalarr = value;
      return true;
    },
    handleChangeXattr(value, id) {
      this.xattrarr.length = 0;
      let list = [];
      id.forEach(function (item, index) {
        list.push(item.data.attrs.id);
      });
      this.xattrarr = list;
      this.xattrvalarr = value;
      return true;
    },
    handleChangeAdt(value) {
      // console.log("value:" + value);
      this.adt = value;
      return true;
    },
    handleChangeChd(value) {
      // console.log("value:" + value);
      this.chd = value;
      return true;
    },
    handleChangeStandard(value) {
      this.standardval = value;
      return true;
    },
    handleChangeSort(value) {
      this.valSort = [];
      this.valSort.push(value);
      this.sortVal = value;
      return true;
    },
    handleChangeSortOrder(value) {
      this.valSortOrder = [];
      this.valSortOrder.push(value);
      this.sortOrderVal = value;
      return true;
    },
    showModalTermin() {
      this.visibleTermin = true;
    },
    showModalUczestnicy() {
      this.visibleUczestnicy = true;
    },
    handleOkUczestnicy(e) {
      this.confirmLoadingUczestnicy = true;
      setTimeout(() => {
        let itemAdt = this.adt;
        let itemChd = this.chd;
        this.participantsTotal(itemAdt, itemChd);
        this.visibleUczestnicy = false;
        this.confirmLoadingUczestnicy = false;
      }, 500);
    },
    disabledDate(current) {
      return current && current < moment().subtract(1, "day");
    },
    getCalendarContainer() {
      return (triggerNode) => triggerNode.parentNode.parentNode;
    },
    clear() {
      this.datesRangeVal = [];
      this.dateFromVal = "";
      this.dateToVal = "";
    },
    handleRangePicker(date, dateString) {
      this.dateFromVal = dateString[0];
      this.dateToVal = dateString[1];
      this.datesRangeVal = [
        moment(this.dateFromVal, "YYYY-MM-DD"),
        moment(this.dateToVal, "YYYY-MM-DD"),
      ];
    },
    handleOkTermin(e) {
      this.confirmLoadingTermin = true;
      if (this.dateFromVal != 0 && this.dateToVal != 0) {
        this.datefrom = this.dateFromVal;
        this.dateto = this.dateToVal;
        this.datesRange = this.datefrom + ` - ` + this.dateto;
      } else {
        this.datefrom = "";
        this.dateto = "";
        this.datesRange = "Dowolny";
      }
      setTimeout(() => {
        this.visibleTermin = false;
        this.confirmLoadingTermin = false;
      }, 500);
    },
    handleCancelTermin(e) {
      this.visibleTermin = false;
    },
    handleCancelUczestnicy(e) {
      this.visibleUczestnicy = false;
    },
    doSomethingWithSlider(event) {
      this.marks = {
        0: event[0] + " zł",
        25000: {
          label: event[1] + " zł",
        },
      };
      this.cenaOd = event[0];
      this.cenaDo = event[1];
      return true;
    },
    getWyzywienie(numer) {
      return this.wyzyw[numer];
    },
    getWyzywienieVal(numer) {
      return this.wyzywvals[numer];
    },
    getTourop(numer) {
      return this.tourop[numer];
    },
    getXattr(numer) {
      return this.xattributes[numer];
    },
    getStandard(id) {
      return this.stan.stans[id];
    },
    getStandardVal(id) {
      return this.stan.stanvals[id];
    },
    getPobytVal(id) {
      return this.pobytvals[id];
    },
    dataDestsReceived(destsData) {
      this.destlocidarr = destsData;
    },
    convertFromHex(val) {
      let numHex = val;
      let hexLength = numHex.length - 1;
      let idArr = [];

      let hexNumArr = [];
      for (let i = 15; i >= 0; i--) {
        if (i > hexLength) {
          hexNumArr[i] = 0;
        } else {
          hexNumArr[i] = parseInt(numHex.charAt(hexLength - i), 16);
        }
      }
      let binNumArr = [];
      for (let i = 0; i < 16; i++) {
        binNumArr[i] = hexNumArr[i].toString(2);
        if (binNumArr[i].length < 4) {
          let tmp = "";
          let len2 = binNumArr[i].length;
          for (let j = 0; j < 4 - len2; j++) {
            tmp += "0";
          }
          tmp += binNumArr[i];
          binNumArr[i] = tmp;
        }
      }
      let binNum = "";
      for (let i = 15; i >= 0; i--) {
        binNum += binNumArr[i];
      }
      if (binNum.length == 64) {
        for (let i = 0; i <= 63; i++) {
          if (binNum.charAt(i) == "1") {
            let id = 64 - i;
            idArr.push(id);
          }
        }
      }
      this.convertResult = idArr;
      return true;
    },
    getQueryParams(newParams, addon) {
      let lparams = this.$route.query;
      if (addon) {
        lparams = newParams;
      }
      if (lparams["dojazd"]) {
        let val = lparams["dojazd"];
        this.valDojazd = val;
        this.dojazdval = val;
      }
      if (lparams["locid"]) {
        // console.log("LOCID:" + decodeURIComponent(lparams["locid"]));
        let vals = decodeURIComponent(lparams["locid"]);
        let arr = vals.split(",");
        this.destlocidarr = arr;
      }
      if (lparams["pobyt"]) {
        let val = decodeURIComponent(lparams["pobyt"]);
        let _this = this;
        let idx = _this.pobytvals.indexOf(val);
        if (idx >= 0) {
          // let val2 = _this.pobyt[idx];
          this.valPobyt = idx;
          this.pobytval = val;
        }
      }
      let val1 = 0;
      if (lparams["cenaOd"]) {
        val1 = Number(lparams["cenaOd"]);
      }
      let val2 = 25000;
      if (lparams["cenaOd"]) {
        val2 = Number(lparams["cenaDo"]);
      }
      this.valCena = [val1, val2];
      this.doSomethingWithSlider(this.valCena);
      if (lparams["wyz"]) {
        let vals = lparams["wyz"];
        let arr = vals.split(",");
        this.valWyz = arr;
        this.wyzywvalarr = arr;
        let list = [];
        let _this = this;
        arr.forEach(function (item, index) {
          let idx = _this.wyzywvals.indexOf(item);
          if (idx >= 0) {
            list.push(_this.getWyzywienie(idx));
          }
        });
        this.wyzywarr = list;
        this.wyzyws = this.wyzywarr.join(", ");
      }
      if (lparams["MTO"]) {
        let vals = lparams["MTO"];
        let arr = vals.split(",");
        this.valTourop = arr;
        this.touropvalarr = arr;
        let list = [];
        let _this = this;
        let items = this.tourop;
        items.forEach(function (item, index) {
          if (_this.valTourop.indexOf(item.kod) >= 0) {
            list.push(item.id);
          }
        });
        this.touroparr = list;
        this.tourops = this.touroparr.join(", ");
      }
      if (lparams["udog"]) {
        let vals = lparams["udog"];
        let xattrOrig = [];
        this.convertFromHex(vals);
        xattrOrig = this.convertResult.toString().split(",");
        this.valXattr = xattrOrig.reverse();
      }
      if (lparams["wyjazd"]) {
        let vals = lparams["wyjazd"];
        let arr = vals.split(",");
        this.valWyjazd = arr;
        this.wyjazdvalarr = arr;
        let list = [];
        let _this = this;
        let items = this.getFiltryItems("trp_depName");
        items.forEach(function (item, index) {
          if (_this.valWyjazd.indexOf(item.gCnt) >= 0) {
            if (item.id instanceof Array) {
              // strange
            } else {
              list.push(item.id);
            }
          }
        });
        this.wyjazdarr = list;
        this.wyjazds = this.wyjazdarr.join(", ");
      }
      if (lparams["standard"]) {
        let val = decodeURIComponent(lparams["standard"]);
        this.valStandard = val;
        this.standardval = val;
      }
      if (lparams["termin"]) {
        let data = decodeURIComponent(lparams["termin"]);
        this.dateFromVal = moment(data, "YYYY-MM-DD");
        this.datefrom = data;
      }
      if (lparams["terminDo"]) {
        let data = decodeURIComponent(lparams["terminDo"]);
        this.dateToVal = moment(data, "YYYY-MM-DD");
        this.dateto = data;
      }
      if (lparams["termin"] && lparams["terminDo"]) {
        this.datesRangeVal = [this.dateFromVal, this.dateToVal];
        this.datesRange = this.datefrom + ` - ` + this.dateto;
      }
      if (lparams["adt"]) {
        let data1 = decodeURIComponent(lparams["adt"]);
        let itemAdt = data1;
        this.participantsTotal(itemAdt);
        if (lparams["chd"]) {
          let data2 = decodeURIComponent(lparams["chd"]);
          let itemAdt = data1;
          let itemChd = data2;
          this.participantsTotal(itemAdt, itemChd);
        }
      }
      if (lparams["adt"]) {
        let data = decodeURIComponent(lparams["adt"]);
        this.valAdt = data;
        this.adt = data;
      }
      if (lparams["chd"] || lparams["inf"]) {
        let datachd = 0;
        if (lparams["chd"]) {
          datachd = decodeURIComponent(lparams["chd"]);
        }
        let datainf = 0;
        if (lparams["inf"]) {
          datainf = decodeURIComponent(lparams["inf"]);
          this.inf = Number(datainf);
        }
        let countchd = Number(datachd) + Number(datainf);
        this.valChd = countchd;
        this.chd = countchd;
        if (lparams["chage"] || lparams["inf"]) {
          let dataages = "";
          if (lparams["chage"]) {
            dataages = decodeURIComponent(lparams["chage"]);
            for (let j = 0; j < this.inf; j++) {
              dataages += ",1";
            }
          } else {
            for (let j = 0; j < this.inf; j++) {
              dataages += "1";
              if (j < this.inf) {
                dataages += ",";
              }
            }
          }
          dataages = "" + dataages;
          let ages = dataages.split(",");
          let _this = this;
          ages.forEach(function (value, index) {
            if (index == 0) {
              _this.valChd1 = _this.wiekdzieci[value];
              _this.chage1 = value;
            } else if (index == 1) {
              _this.valChd2 = _this.wiekdzieci[value];
              _this.chage2 = value;
            } else if (index == 2) {
              _this.valChd3 = _this.wiekdzieci[value];
              _this.chage3 = value;
            } else if (index == 3) {
              _this.valChd4 = _this.wiekdzieci[value];
              _this.chage4 = value;
            }
          });
        }
      }
      if (lparams["sort"]) {
        let val = lparams["sort"];
        let nval = Number(val);
        this.handleChangeSort(nval);
      }
      if (lparams["order"]) {
        let val = lparams["order"];
        this.handleChangeSortOrder(val);
      }
    },
    szukaj() {
      // var parametry = "?";
      let parArr = [];
      let childAges = [];
      let infAges = [];
      if (this.dojazdval != "") {
        parArr.push("dojazd=" + this.dojazdval);
      }
      if (Array.isArray(this.destlocidarr) && this.destlocidarr.length > 0) {
        parArr.push("locid=" + this.destlocidarr.join(","));
      }
      // ... reszta parametrów
      if (this.pobytval != "") {
        parArr.push("pobyt=" + this.pobytval);
      }
      if (this.wyjazdvalarr.length > 0) {
        parArr.push("wyjazd=" + this.wyjazdvalarr.join(","));
      }
      if (this.datefrom != "" && this.datesRange != "Dowolny") {
        parArr.push("termin=" + this.datefrom);
      }
      if (this.dateto != "" && this.datesRange != "Dowolny") {
        parArr.push("terminDo=" + this.dateto);
      }
      if (this.adt > 0) {
        parArr.push("adt=" + this.adt);
      }
      if (this.chd > 0) {
        if (this.chage1 > 1) {
          childAges.push(this.chage1);
        } else {
          infAges.push(this.chage1);
        }
        if (this.chd > 1) {
          if (this.chage2 > 1) {
            childAges.push(this.chage2);
          } else {
            infAges.push(this.chage2);
          }
        }
        if (this.chd > 2) {
          if (this.chage3 > 1) {
            childAges.push(this.chage3);
          } else {
            infAges.push(this.chage3);
          }
        }
        if (this.chd > 3) {
          if (this.chage4 > 1) {
            childAges.push(this.chage4);
          } else {
            infAges.push(this.chage4);
          }
        }
        if (childAges.length > 0) {
          childAges.sort(function (a, b) {
            return a - b;
          });
          parArr.push("chage=" + childAges.join(","));
        }
        let chdd = this.chd;
        if (infAges.length > 0) {
          parArr.push("inf=" + infAges.length);
          chdd -= infAges.length;
        }
        if (chdd != this.chd) {
          parArr.push("chd=" + chdd);
        } else {
          parArr.push("chd=" + this.chd);
        }
      }
      if (this.wyzywvalarr.length > 0) {
        parArr.push("wyz=" + this.wyzywvalarr.join(","));
      }
      if (this.touropvalarr.length > 0) {
        parArr.push("MTO=" + this.touropvalarr.join(","));
      }
      if (this.xattrarr.length > 0) {
        let selectedAttr = this.xattrarr;
        let xattrInt = selectedAttr.map((str) => parseInt(str));
        let xattrSum = xattrInt.reduce((a, b) => a + b, 0);
        let xattrSumHex = xattrSum.toString(16);
        parArr.push("udog=" + xattrSumHex);
      }
      if (this.standardval != "") {
        parArr.push("standard=" + this.standardval);
      }
      parArr.push("cenaOd=" + this.cenaOd);
      parArr.push("cenaDo=" + this.cenaDo);

      parArr.push("sort=" + this.sortVal);
      if (this.sortOrderVal != "") {
        parArr.push("order=" + this.sortOrderVal);
      }

      parArr.push("page=" + 1);
      //alert("Parametry: " + parArr.join("&"));
      var newURL = parArr.join("&");
      var newBase = this.$route.path;
      if (newBase === "undefined" || newBase === "" || newBase === "/") {
        newBase = "/oferta/szukaj.xml";
      }

      // Fix na błąd routera przy wyszukiwaniu, kiedy url jest taki sam, jak ten, do którego odnosi się akcja "Szukaj",
      // Vue protestuje przed ponownym renderowaniem tej samej strony:
      // Uncaught (in promise) NavigationDuplicated: Avoided redundant navigation to current location (...)
      // Było tylko: this.$router.push({ path: newBase + "?" + newURL });

      let currentPathParams = new URLSearchParams(this.$route.query)
        .toString()
        .replace(/%2C/g, ",");
      let currentPath = this.$route.path + "?" + currentPathParams;
      let newCurrentPath = newBase + "?" + newURL;

      if (currentPath != newCurrentPath) {
        this.$router.push({ path: newBase + "?" + newURL });
      }
    },
    participantsTotal(itemAdt, itemChd) {
      let singluarAdt = itemAdt + " dorosły";
      let pluralAdt = itemAdt + " dorosłych";
      let singularChd = ", " + itemChd + " dziecko";
      let pluralChd = ", " + itemChd + " dzieci";

      if (!itemChd) {
        this.valUczestnicy = itemAdt == 1 ? singluarAdt : pluralAdt;
      } else {
        this.valUczestnicy =
          (itemAdt == 1 ? singluarAdt : pluralAdt) +
          (itemChd == 1 ? singularChd : pluralChd);
      }
    },
    disableUnwantedTyping() {
      const selects = document.querySelectorAll(
        ".select-multiple .ant-select-search__field"
      );
      for (let input of selects) {
        input.setAttribute("readonly", true);
      }
    },
  },
  mounted() {
    var path = this.$route.path;
    if (
      path.indexOf("/wyjazdy/") !== -1 ||
      path.indexOf("/wakacje/") !== -1 ||
      path.indexOf("/last-minute/") !== -1 ||
      path.indexOf("/rodzaj-oferty/") !== -1
    ) {
      if (
        path.indexOf("/wakacje/") !== -1 ||
        path.indexOf("/wyjazdy/") !== -1
      ) {
        var restURL = path.substring(9);
        if (restURL !== "oferty.xml") {
          this.isKierunkiDisabled = false;
        } else {
          this.isKierunkiDisabled = true;
        }
      } else if (path.indexOf("/last-minute/") !== -1) {
        var restURL = path.substring(13);
        if (restURL !== "oferty.xml") {
          this.isKierunkiDisabled = false;
        } else {
          this.isKierunkiDisabled = true;
        }
      } else if (path.indexOf("/rodzaj-oferty/") !== -1) {
        this.isKierunkiDisabled = true;
      }
    } else {
      this.isKierunkiDisabled = true;
    }
    this.getFiltry().then((data) => {
      //alert('OFERTY:' + JSON.stringify(data.page.response));
      this.filtry = data.page.response;
      this.getQueryParams(null, false);
      if (path === "/") {
        this.valPobyt = 2;
        this.pobytval = this.getPobytVal(2);
      }
    });
    this.disableUnwantedTyping();
    var that = this;
    this.$root.$on("update:addon", (val1) => {
      // console.log("Got ADDON:" + val1);
      that.addon = val1;
      var newquery = Object.assign({}, that.$route.query);
      // var vars = [];
      var hashar = [];
      var hashes = that.addon.split("&");
      for (var i = 0; i < hashes.length; i++) {
        hashar = hashes[i].split("=");
        if (hashar[0] == "allInclusive" && hashar[1] == 1) {
          hashar[0] = "wyz";
          hashar[1] = "AI";
        } else if (hashar[0] == "locid") {
          that.$root.$emit("update:locid", hashar[1]);
        }
        newquery[hashar[0]] = hashar[1];
      }
      that.getQueryParams(newquery, true);
    });
    window.onresize = () => {
      this.windowWidth = window.innerWidth;
    };
  },
  watch: {
    $route(to, from) {
      var path = this.$route.path;
      if (
        path.indexOf("/wakacje/") !== -1 ||
        path.indexOf("/wyjazdy/") !== -1
      ) {
        if (path.substring(9).indexOf("oferty.xml") !== -1) {
          this.isKierunkiDisabled = true;
        } else {
          this.isKierunkiDisabled = false;
        }
      } else if (path.indexOf("/last-minute/") !== -1) {
        if (path.substring(13).indexOf("oferty.xml") !== -1) {
          this.isKierunkiDisabled = true;
        } else {
          this.isKierunkiDisabled = false;
        }
      } else if (path.indexOf("/rodzaj-oferty/") !== -1) {
        this.isKierunkiDisabled = true;
      } else {
        this.isKierunkiDisabled = true;
      }
    },
  },
  components: {
    T1KierunkiModal,
    T1KierunkiDropdown,
  },
};
</script>

<style lang="scss" scoped>
@import "@/components/T1Searchers/T1MainSearcherStyles";
</style>
